// extracted by mini-css-extract-plugin
export default {"wrapper":"ContainerWrapper_wrapper__EWwIx"};